import { AutogenModelPayeeDrivers, AutogenRowPayeeDrivers } from "./autogen/AutogenModelPayeeDrivers";

export class ModelPayeeDrivers extends AutogenModelPayeeDrivers<RowPayeeDrivers> {
	constructor() {
		super(RowPayeeDrivers);
	}
}

export class RowPayeeDrivers extends AutogenRowPayeeDrivers {
}